
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ouvidoria",
      function () {
        return require("private-next-pages/ouvidoria/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ouvidoria"])
      });
    }
  